import { US_STATES, CDL_CLASSES, TRAILER_TYPES } from "@/components/auth/signupConstants";

export const DriverFilterBar = ({ filters, setFilters }) => {
  const update = (key) => (e) => setFilters((f) => ({ ...f, [key]: e.target.value }));

  return (
    <div data-testid="driver-filter-bar" className="flex flex-wrap gap-3 bg-white border border-rr-line rounded-2xl p-4">
      <select data-testid="driver-filter-state" value={filters.state} onChange={update("state")} className="border border-rr-line rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:border-rr-orange">
        <option value="">All States</option>
        {US_STATES.map((s) => (<option key={s} value={s}>{s}</option>))}
      </select>
      <select data-testid="driver-filter-cdl-class" value={filters.cdl_class} onChange={update("cdl_class")} className="border border-rr-line rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:border-rr-orange">
        <option value="">Any CDL Class</option>
        {CDL_CLASSES.map((c) => (<option key={c} value={c}>CDL Class {c}</option>))}
      </select>
      <select data-testid="driver-filter-trailer-type" value={filters.trailer_type} onChange={update("trailer_type")} className="border border-rr-line rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:border-rr-orange">
        <option value="">Any Trailer Type</option>
        {TRAILER_TYPES.map((t) => (<option key={t} value={t}>{t}</option>))}
      </select>
    </div>
  );
};
